import React from 'react';
import { Input, Label } from '../Form';
import UserPicker from '../User/UserPicker';
import { format, parseISO } from 'date-fns';
import FormRow from '../Form/FormRow';
import Form from '../Form/Form';
import FormColumn from '../Form/FormColumn';
import CustomerPicker from '../Customer/CustomerPicker';
import { RecycledWaterInspectionInput } from './types';

type RecycledWaterInspectionEditFormProps = {
  value: RecycledWaterInspectionInput;
  onChange: (rwInspection: RecycledWaterInspectionInput) => void;
  siteAddressId: string;
};

const RecycledWaterInspectionEditForm: React.FC<
  RecycledWaterInspectionEditFormProps
> = ({ onChange, value, siteAddressId }) => {
  return (
    <Form>
      <FormRow>
        <FormColumn>
          <Label htmlFor="assignedToProfileId">Assigned to</Label>
          <UserPicker
            autoFocus
            userId={value.outboundAssignment?.vendorProfileId}
            onChange={(user) => {
              onChange({
                ...value,
                outboundAssignment: user
                  ? {
                      ...value.outboundAssignment,
                      vendorProfileId: user.profileId,
                    }
                  : undefined,
              });
            }}
          />
        </FormColumn>
        <FormColumn>
          <Label htmlFor="scheduled">Scheduled for</Label>
          <Input
            type="datetime-local"
            name="scheduled"
            value={
              value.scheduled
                ? format(value.scheduled, 'yyyy-MM-dd HH:mm:ss')
                : ''
            }
            onChange={(e) => {
              let scheduled: number | undefined;
              if (e.target.value) {
                value = parseISO(e.target.value).valueOf() as any;
              } else {
                scheduled = undefined;
              }
              onChange({
                ...value,
                scheduled,
              });
            }}
          />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn>
          <Label>Site Contact</Label>
          <CustomerPicker
            customerProfileId={value.contactProfileId}
            serviceAddressId={siteAddressId}
            serviceAddressWhere={{
              active: true,
              addressId: siteAddressId,
            }}
            isClearable
            onChange={(customer) =>
              onChange({
                ...value,
                contactProfileId: customer?.profileId,
              })
            }
          />
        </FormColumn>
      </FormRow>
    </Form>
  );
};

export default RecycledWaterInspectionEditForm;
